<script setup lang="ts">
import { computed } from 'vue';
import { NTag } from 'naive-ui';

interface Props {
  variant?: 'primary' | 'accent' | 'success' | 'warning' | 'danger' | 'slate' | 'position';
  pill?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  pill: false,
});

const naiveType = computed(() => {
  switch (props.variant) {
    case 'success': return 'success';
    case 'danger': return 'error';
    case 'warning': return 'warning';
    case 'accent':
    case 'primary': return 'info';
    default: return 'default';
  }
});
</script>

<template>
  <NTag
    :type="naiveType"
    :round="pill"
    size="small"
    :bordered="true"
    class="font-bold text-[11px] uppercase tracking-wide inline-flex items-center gap-1 shadow-sm"
  >
    <slot />
  </NTag>
</template>